<template>
  <form method="post" @submit.prevent="submit">
    <div class="row">
      <div class="col-md-6">
        <div class="card card-body mb-3">
          <h5>
            {{ $t('phrase.request_research') }}
          </h5>
          <transition name="fade-up">
            <p class="text-muted" v-if="showText">
              We kunnen elke commercial en andere marketinguiting uitgebreid testen in een
              doelgroep naar keuze, standaard in <strong>een groep van 100 mensen</strong>.
              Vrijwel elke vraag is mogelijk en valt volledig zelf samen te stellen
              (samen met ons). We hebben de resultaten binnen ongeveer 24u tot enkele dagen na
              livezetten van het onderzoek. Resultaten worden weergegeven op ons
              <strong>live dashboard</strong> en in een
              <strong>downloadbaar .csv bestand</strong>. We vragen hiervoor standaard
              <strong>€1250</strong>.
            </p>
          </transition>

          <transition name="fade-up">
            <p class="text-muted" v-if="showText">
              We kunnen alles testen:
              <strong>afbeeldingen, schetsen, tekst, animaties, video's etc.</strong> en
              in elke fase: concept, schets, pre-test en of posttest. Klik
              <a
                href="https://commercialreview.nl/commercials/commercial/start/357"
                target="_blank"
              >
                hier
              </a>
              als u een voorbeeldtest wilt zien.
            </p>
          </transition>
        </div>

        <div class="mb-3">
          <v-partner-carousel
            :per-page="4"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div id="accordion">
          <div class="card mb-2">
            <div class="card-header">
              <a
                class="text-body"
                href="#"
                @click.prevent="tabNumber = 1"
              >
                1. {{ $t('word.general_info') }}
              </a>
            </div>

            <v-collapse-transition>
              <div
                v-show="tabNumber === 1"
              >
                <div class="card-body">
                  <div class="mb-3">
                    <v-single-select
                      id="register-research-research-type"
                      v-model="data.test_type"
                      :errors="errors.test_type"
                      label="word.research_type"
                      help-text="sentence.pre_or_post_test"
                      :choices="testTypeOptions"
                    />
                  </div>

                  <div class="mb-3">
                    <v-text-area
                      id="register-research-description"
                      v-model="data.test_description"
                      :errors="errors.test_description"
                      label="phrase.description_research"
                      help-text="sentence.describe_the_research_detailed"
                      :rows="6"
                    />
                  </div>

                  <div>
                    <v-date-picker
                      id="register-research-date"
                      v-model="data.test_date"
                      :errors="errors.test_date"
                      label="phrase.research_date"
                      help-text="sentence.research_results_date"
                    />
                  </div>
                </div>
                <div class="card-footer">
                  <v-button
                    id="register-research-to-step-2"
                    style-type="secondary"
                    text="word.next"
                    :block="true"
                    @click="tabNumber = 2"
                  />
                </div>
              </div>
            </v-collapse-transition>
          </div>

          <div class="card mb-2">
            <div class="card-header">
              <a
                class="text-body"
                href="#"
                @click.prevent="tabNumber = 2"
              >
                2. {{ $t('word.target_group_information') }}
              </a>
            </div>
            <v-collapse-transition>
              <div
                v-show="tabNumber === 2"
              >
                <div class="card-body">
                  <div class="mb-3">
                    <div class="text-bold">
                      {{ $t('word.gender') }}
                    </div>

                    <v-check-box
                      id="register-research-gender-m"
                      label="word.men"
                      v-model="data.target_group_gender.men"
                    />

                    <v-check-box
                      id="register-research-gender-f"
                      label="word.women"
                      v-model="data.target_group_gender.women"
                    />

                    <v-check-box
                      id="register-research-gender-o"
                      label="phrase.other_genders"
                      v-model="data.target_group_gender.other"
                    />
                  </div>

                  <div class="mb-3">
                    <label class="text-bold" for="slider">
                      {{ $t('word.age') }}
                    </label>
                    <v-slider
                      id="slider"
                      v-model="data.target_group_age_range"
                      :errors="errors.target_group_age_range"
                      :dot-options="dotOptions"
                      :order="false"
                    />
                  </div>

                  <div
                    class="alert alert-info"
                    v-html="targetGroupSentence"
                  />

                  <hr/>

                  <div>
                    <v-text-area
                      id="register-research-target-group-remarks"
                      v-model="data.target_group_remarks"
                      :errors="errors.target_group_remarks"
                      label="phrase.additional_requirements"
                      help-text="sentence.additional_requirements"
                    />
                  </div>

                </div>
                <div class="card-footer">
                  <v-button
                    id="register-research-to-step-3"
                    style-type="secondary"
                    text="word.next"
                    :block="true"
                    @click="tabNumber = 3"
                  />
                </div>
              </div>
            </v-collapse-transition>
          </div>

          <div class="card mb-5">
            <div class="card-header">
              <a
                class="text-body"
                href="#"
                @click.prevent="tabNumber = 3"
              >
                3. {{ $t('word.organisation_data') }}
              </a>
            </div>
            <v-collapse-transition>
              <div
                v-show="tabNumber === 3"
              >
                <div class="card-body">
                  <div class="mb-3">
                    <v-text-input
                      id="register-research-organisation-name"
                      v-model="data.org_name"
                      :errors="errors.org_name"
                      :required="true"
                      label="word.name"
                    />
                  </div>
                  <div class="mb-3">
                    <v-text-input
                      id="register-research-organisation-email"
                      v-model="data.org_email"
                      :errors="errors.org_email"
                      :required="true"
                      label="word.organisation_email"
                      type="email"
                    />
                  </div>
                  <div class="mb-3">
                    <v-text-input
                      id="register-research-organisation-phone"
                      v-model="data.org_phone"
                      :errors="errors.org_phone"
                      label="word.phone"
                    />
                  </div>
                  <div class="mb-3">
                    <v-text-area
                      id="register-research-organisation-remarks"
                      v-model="data.remarks"
                      :errors="errors.remarks"
                      label="phrase.remarks"
                    />
                  </div>
                </div>
                <div class="card-footer">
                  <v-button
                    id="register-research-submit"
                    style-type="primary"
                    text="word.send"
                    type="submit"
                    :block="true"
                  />
                </div>
              </div>
            </v-collapse-transition>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import moment from 'moment';
import nl from 'moment/locale/nl';

import { CollapseTransition } from '@ivanv/vue-collapse-transition';

import Button from '@/common/components/Button.vue';
import CheckBox from '@/common/components/inputs/CheckBox.vue';
import DatePicker from '@/common/components/inputs/DatePicker.vue';
import PartnerCarousel from '@/common/components/carousels/PartnerCarousel.vue';
import SingleSelect from '@/common/components/inputs/SingleSelect.vue';
import TextArea from '@/common/components/inputs/TextArea.vue';

import TextInput from '@/common/components/inputs/TextInput.vue';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';
import { toFormattedDate } from '@/common/utils/formatting';
import { mapGetters } from 'vuex';
import { setBreadcrumbs } from '@/common/utils/breadcrumbs';
import { registerCustomResearch } from '@/organisation/api';

moment.updateLocale('nl', nl);

const GENDER_OPTIONS = {
  women: 'word.women',
  men: 'word.men',
  other: 'phrase.other_genders',
};

export default {
  name: 'RequestResearch',
  components: {
    'v-button': Button,
    'v-check-box': CheckBox,
    'v-collapse-transition': CollapseTransition,
    'v-date-picker': DatePicker,
    'v-partner-carousel': PartnerCarousel,
    'v-single-select': SingleSelect,
    'v-slider': VueSlider,
    'v-text-area': TextArea,
    'v-text-input': TextInput,
  },
  data() {
    return {
      tabNumber: 1,
      showText: false,
      errors: {},
      data: {
        test_description: '',
        test_type: null,
        test_date: null,
        target_group_gender: {
          men: true,
          women: true,
          other: true,
        },
        target_group_age_range: [0, 100],
        target_group_remarks: '',
        org_name: '',
        org_email: '',
        org_phone: '',
        remarks: '',
      },
    };
  },
  computed: {
    ...mapGetters(['org']),
    dotOptions() {
      return [
        {
          min: 0,
          max: this.maxAge - 10,
        },
        {
          min: this.minAge + 10,
          max: 100,
        },
      ];
    },
    maxAge() {
      return this.data.target_group_age_range[1];
    },
    minAge() {
      return this.data.target_group_age_range[0];
    },
    minDate() {
      return this.getMinDate();
    },
    genderChoice() {
      let genders = Object.entries(this.data.target_group_gender)
        .filter((el) => el[1]);
      if (genders.length === 3 || genders.length === 0) {
        genders = this.$t('phrase.any_gender');
      } else {
        const divider = ` ${this.$t('word.and')} `;
        genders = genders.map((el) => this.$t(GENDER_OPTIONS[el[0]]))
          .join(divider);
      }
      return genders.toLowerCase();
    },
    targetGroupSentence() {
      const params = {
        minAge: this.minAge,
        maxAge: this.maxAge,
        gender: this.genderChoice,
      };

      return this.$t('sentence.age_gender', params);
    },
    testTypeOptions() {
      return [
        {
          key: 'pre-test',
          value: 'word.pre_test',
        },
        {
          key: 'post-test',
          value: 'word.post_test',
        },
        {
          key: 'pre-or-post-test',
          value: 'sentence.pre_or_post_test_unsure',
        },
        {
          key: 'pre-and-post-test',
          value: 'phrase.pre_and_post_test',
        },
      ];
    },
  },
  methods: {
    getMinDate() {
      return moment()
        .add(1, 'days')
        .toDate();
    },
    async submit() {
      let data = { ...{}, ...this.data };
      const ageData = {
        target_group_age_min: data.target_group_age_range[0],
        target_group_age_max: data.target_group_age_range[1],
      };
      delete data.target_group_age_range;

      data = { ...data, ...ageData };
      data.test_date = toFormattedDate(data.test_date);
      data.target_group_gender = this.genderChoice;

      const response = await registerCustomResearch(data);
      if (response.status === 200) {
        await this.$router.push({
          name: 'success',
          query: { msg: 'sentence.request_test_success' },
        });
        return;
      }
      if (response.status === 400) {
        this.errors = response.data;

        // Brings the user to tab 1 or 2 in case a server side error
        // occurs for one of these form fields;
        if ('target_group_age_min' in this.errors
          || 'target_group_age_max' in this.errors
          || 'target_group_remarks' in this.errors) {
          this.tabNumber = 2;
        }

        if ('test_type' in this.errors
          || 'test_description' in this.errors
          || 'test_date' in this.errors) {
          this.tabNumber = 1;
        }
      }
    },
  },
  created() {
    if (this.$route.query['test-type']) {
      this.data.test_type = this.$route.query['test-type'];
    }

    setTimeout(() => {
      this.showText = true;
    }, 1);

    if (this.org) {
      setBreadcrumbs('organisation.registerTest', [this.$route.query.type]);
    }
  },
};
</script>

<style scoped>
.collapse {
  display: block;
}
</style>
